import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type { Key } from './key'

export enum Purpose {
  /**
   * Used to import data into the DMS
   */
  // eslint-disable-next-line @typescript-eslint/no-shadow -- unrelated to the DmsUpload namespace below
  DmsUpload = 'dms-upload',
  /**
   * Files visible to and managed by end users
   */
  FileManagement = 'files',
}
// Needs to be before namespace is defined
const PURPOSES: ReadonlySet<Purpose> = new Set(
  Object.values(Purpose) as Purpose[],
)
export namespace Purpose {
  export const ALL: readonly Purpose[] = Array.from(PURPOSES)
  export const isPurpose = TypeChecker.Factory.oneOf(PURPOSES)
  export const assertIsPurpose: TypeAsserter<Purpose> =
    TypeAsserter.Factory.from(isPurpose)
}

export namespace DmsUpload {
  export const REPLACE_EXISTING_DATA_QUALIFIER = 'replace-existing-data'
}

/**
 * It is very important that {@link Purpose} and
 * {@link Key.Parts.Context.ParentFolder} don't ever accidentally use the same name
 */
type EnsureNoCollision = Satisfies<
  Extract<`${Purpose}`, `${Key.Parts.Context.ParentFolder}`>,
  never
>
